import { Box } from '@mui/material'
import { BoxProps } from '@mui/system'

import * as styles  from './HtmlPreviewer.module.css'
import { usePreviewerContext } from './../../context/PreviewerContextProvider'

const Previewer = (props : BoxProps): JSX.Element | null => {
  const { htmlPreviewRef, previewUrl, activeDrawingNo, activeApplicationId } = usePreviewerContext()
  return (
    <Box
      position="relative"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...props}
    >
      <div className={`${styles.demoDevice} ${styles.ios}`}>
        <figure>
          <svg className={`${styles.demoDeviceBar}`} viewBox="0 0 1384.3 40.3">
            <path className="st0" d="M1343 5l18.8 32.3c.8 1.3 2.7 1.3 3.5 0L1384 5c.8-1.3-.2-3-1.7-3h-37.6c-1.5 0-2.5 1.7-1.7 3z" />
            <circle
              className="st0"
              cx="1299"
              cy="20.2"
              r="20"
            />
            <path className="st0" d="M1213 1.2h30c2.2 0 4 1.8 4 4v30c0 2.2-1.8 4-4 4h-30c-2.2 0-4-1.8-4-4v-30c0-2.3 1.8-4 4-4zM16 4.2h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
          </svg>
          <svg className={`${styles.demoDeviceNotch}`} viewBox="0 0 219 31">
            <path d="M0 1V0h219v1a5 5 0 0 0-5 5v3c0 12.15-9.85 22-22 22H27C14.85 31 5 21.15 5 9V6a5 5 0 0 0-5-5z" fillRule="evenodd" />
          </svg>
          {activeDrawingNo && activeApplicationId && previewUrl && <iframe
            id={activeDrawingNo}
            ref={htmlPreviewRef}
            loading="lazy"
            allow="camera; microphone; geolocation"
            src={`${previewUrl}/?id=${activeApplicationId}&draw=${activeDrawingNo}&liveview=true`}
          />}
        </figure>
      </div>

      {/* goo filter for notch shape */}
      <svg viewBox="0 0 0 0" height="0" width="0">
        <filter id="goo" colorInterpolationFilters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 8 -1"
            result="cm"
          />
          <feBlend in="sourceGraphic" in2="cm" mode="multiply" />
        </filter>
      </svg>
    </Box>
  )
}
export default Previewer
